import request from '@/services/interceptor.js'


export const get_download = () => {
  return request({
    url: '/api/download',
    method: 'get'
  })
};